import { PagePermissions } from './page-permissions';
import { ActionTypeEnum } from 'itcores-fw';

export const ActionPermissions = {
  [ActionTypeEnum.create]: PagePermissions.Create,
  [ActionTypeEnum.details]: PagePermissions.Details,
  [ActionTypeEnum.edit]: PagePermissions.Update,
  [ActionTypeEnum.activate]: PagePermissions.Delete,
  [ActionTypeEnum.deactivate]: PagePermissions.Delete,
  [ActionTypeEnum.delete]: PagePermissions.Delete,
  [ActionTypeEnum.print]: PagePermissions.Print
};
